import { FC } from 'react';
import styled from 'styled-components';
import { themeColors, themeSizes } from '../../../../styles/globalStyleVars';
import { ButtonRow } from '../../../Styled/ButtonRow';
import GlobalDrawerButton from '../../../Global/GlobalDrawerButton';

export const FlowButtonRow = styled(ButtonRow)`
  width: 100%;
  padding: ${themeSizes.lg};
  box-shadow: 0px -2px 4px 0px rgba(91, 103, 112, 0.24);
  background-color: ${themeColors.primaryWhite};
  flex-shrink: 0;
`;

const buttonStyles = { minWidth: '97px', minHeight: '40px' };

interface Props {
  handleSaveClick: () => void;
  handleBackClick: () => void;
  saveDisabled?: boolean;
  cancelDisabled?: boolean;
}

const ServiceHistoryFooter: FC<Props> = ({
  handleSaveClick,
  handleBackClick,
  saveDisabled = false,
  cancelDisabled = false,
}) => {
  return (
    <FlowButtonRow $noMargin>
      <div style={{ display: 'flex', gap: themeSizes.sm }}>
        <GlobalDrawerButton
          buttonText='Cancel'
          handleClick={handleBackClick}
          variant='outlined'
          styles={buttonStyles}
          disabled={cancelDisabled}
          size='sm'
        />
        {/* Commenting out delete button for now - not needed for service history v1 */}
        {/* <GlobalDrawerButton
          buttonText='Delete'
          handleClick={handleBackClick}
          variant='outlined'
          styles={buttonStyles}
          size='sm'
          startIcon={<IconTrash size={16} />}
        /> */}
      </div>
      <GlobalDrawerButton
        buttonText='Save'
        handleClick={handleSaveClick}
        styles={buttonStyles}
        disabled={saveDisabled}
        size='sm'
      />
    </FlowButtonRow>
  );
};

export default ServiceHistoryFooter;
